var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 200,
    viewBox: "0 0 189 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5927_53070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5 188.627C146.588 188.627 188.811 146.404 188.811 94.3161C188.811 42.2286 146.588 0 94.5 0C42.4124 0 0.189362 42.2231 0.189362 94.3106C0.189362 146.398 42.4124 188.621 94.5 188.621V188.627Z",
    fill: "#B9E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.565 78.9488C164.78 78.9488 181.975 61.7491 181.975 40.5388C181.975 19.3285 164.78 2.12871 143.565 2.12871C122.349 2.12871 105.155 19.323 105.155 40.5388C105.155 61.7545 122.349 78.9488 143.565 78.9488Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.796 61.1126C111.349 59.8124 113.148 58.0951 114.191 56.0103C115.485 53.4262 115.804 50.0741 114.3 49.3389C113.428 48.911 112.325 49.3169 111.694 49.9479C110.668 50.9683 109.84 51.9339 109.84 51.9339",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.796 61.1126C111.349 59.8124 113.148 58.0951 114.191 56.0103C115.485 53.4262 115.804 50.0741 114.3 49.3389C113.428 48.911 112.325 49.3169 111.694 49.9479C110.668 50.9683 109.84 51.9339 109.84 51.9339",
    stroke: "#1E1F24",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1612 51.7694C82.1612 51.7694 81.2394 47.4626 78.2549 48.1319C76.6035 48.505 76.6474 51.4511 77.7885 54.1504C78.7102 56.3285 80.422 58.1884 81.9088 59.6039",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1612 51.7694C82.1612 51.7694 81.2394 47.4626 78.2549 48.1319C76.6035 48.505 76.6474 51.4511 77.7885 54.1504C78.7102 56.3285 80.422 58.1884 81.9088 59.6039",
    stroke: "#1E1F24",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46 81.2257C106.46 81.2257 103.256 88.2263 95.8277 88.4402C88.3937 88.6542 84.6081 81.9883 84.6081 81.9883L88.6186 71.5038H102.285L106.46 81.2257Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.987 51.0726C110.987 51.0726 111.118 47.7369 110.542 45.7618C109.966 43.7867 109.873 42.7498 108.457 41.3069C107.042 39.8585 106.998 38.3716 104.321 38.048C103.059 37.8943 101.731 38.1138 100.733 37.9218C99.6078 37.7023 98.8068 37.0769 97.2816 37.0604L95.9978 37.0439C94.4671 37.0275 93.6551 37.6365 92.5249 37.834C91.5209 38.0095 90.1932 37.7572 88.9313 37.8888C86.2485 38.1577 86.1717 39.65 84.7288 41.06C83.2859 42.47 83.0938 43.1887 82.4794 45.1473C81.8594 47.1059 81.9198 50.4471 81.9198 50.4471C81.9198 50.4471 81.821 61.579 82.5946 64.0972C83.3682 66.61 84.054 70.7357 91.2466 77.2864C94.3135 80.0735 99.0811 79.6127 101.83 77.281C108.188 71.8933 108.973 68.2339 109.961 63.971C110.987 59.5106 110.981 51.0836 110.981 51.0836",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.987 51.0726C110.987 51.0726 111.118 47.7369 110.542 45.7618C109.966 43.7867 109.873 42.7498 108.457 41.3069C107.042 39.8585 106.998 38.3716 104.321 38.048C103.059 37.8943 101.731 38.1138 100.733 37.9218C99.6078 37.7023 98.8068 37.0769 97.2816 37.0604L95.9978 37.0439C94.4671 37.0275 93.6551 37.6365 92.5249 37.834C91.5209 38.0095 90.1932 37.7572 88.9313 37.8888C86.2485 38.1577 86.1717 39.65 84.7288 41.06C83.2859 42.47 83.0938 43.1887 82.4794 45.1473C81.8594 47.1059 81.9198 50.4471 81.9198 50.4471C81.9198 50.4471 81.821 61.579 82.5946 64.0972C83.3682 66.61 84.054 70.7357 91.2466 77.2864C94.3135 80.0735 99.0811 79.6127 101.83 77.281C108.188 71.8933 108.973 68.2339 109.961 63.971C110.987 59.5106 110.981 51.0836 110.981 51.0836",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.073 193.965C155.371 195.649 153.945 197.257 151.783 198.135C150.34 198.716 148.563 198.98 145.666 198.53C146.16 198.53 147.641 198.135 149.177 197.328C150.626 196.566 152.118 195.452 152.908 193.96C154.142 191.633 154.581 188.994 153.456 186.575C152.666 184.858 150.203 182.778 150.203 182.778C152.524 183.387 154.236 183.969 154.773 184.479C157.544 187.129 157.483 190.558 156.073 193.97V193.965Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.902 193.96C152.112 195.452 150.62 196.566 149.172 197.328C147.635 198.129 146.154 198.524 145.66 198.53C145.638 198.524 145.616 198.53 145.595 198.519C144.042 198.277 141.579 197.877 135.417 196.598C132.367 195.968 128.126 194.673 126.255 194.146C122.672 193.137 121.065 192.506 121.065 192.506C121.065 192.506 124.445 189.647 125.509 186.41C127.352 180.787 125.416 178.85 125.416 178.85C125.416 178.85 131.659 179.53 139.186 180.962C142.687 181.626 148.557 182.345 150.209 182.773C150.209 182.773 152.672 184.852 153.462 186.569C154.581 188.994 154.148 191.628 152.913 193.954L152.902 193.96Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.371 185.176C144.371 185.176 142.286 189.104 141.787 194.514L144.371 185.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.371 185.176C144.371 185.176 142.286 189.104 141.787 194.514",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.112 184.528C141.112 184.528 139.027 188.457 138.528 193.866L141.112 184.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.112 184.528C141.112 184.528 139.027 188.457 138.528 193.866",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.996 183.354C137.996 183.354 135.911 187.283 135.412 192.692L137.996 183.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.996 183.354C137.996 183.354 135.911 187.283 135.412 192.692",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.726 182.663C134.726 182.663 132.641 186.591 132.142 192.001L134.726 182.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.726 182.663C134.726 182.663 132.641 186.591 132.142 192.001",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.724 187.321C132.724 187.321 129.821 184.644 131.193 183.234C132.57 181.829 133.409 184.852 132.724 187.321Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.724 187.321L135.549 185.5",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.724 187.321C132.724 187.321 128.823 187.925 129.174 189.861C129.53 191.798 131.917 189.757 132.724 187.321Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.724 187.321L134.051 190.415",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7894 193.526L79.0943 191.995L65.6143 186.542L65.0108 191.458L69.7894 193.526Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6712 195.007C35.3734 196.692 36.7999 198.299 38.9615 199.177C40.4044 199.759 42.182 200.022 45.0788 199.572C44.585 199.572 43.1037 199.177 41.5675 198.371C40.1191 197.608 38.6268 196.494 37.8368 195.002C36.6024 192.676 36.1635 190.037 37.2882 187.617C38.0782 185.9 40.5416 183.821 40.5416 183.821C38.2209 184.43 36.5091 185.011 35.9714 185.521C33.2008 188.171 33.2612 191.6 34.6712 195.013V195.007Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8368 195.002C38.6268 196.494 40.1191 197.608 41.5675 198.371C43.1037 199.172 44.585 199.567 45.0788 199.572C45.1008 199.567 45.1227 199.572 45.1446 199.561C46.6973 199.32 49.1607 198.919 55.3219 197.641C58.3723 197.01 62.6132 195.715 64.4841 195.188C68.0667 194.179 69.7894 193.532 69.7894 193.532C69.7894 193.532 65.6088 190.92 64.5499 187.683C62.7065 182.06 65.3235 179.898 65.3235 179.898C65.3235 179.898 58.9703 182.29 51.3113 182.696C47.7562 182.883 42.182 183.393 40.5306 183.821C40.5306 183.821 38.0672 185.9 37.2772 187.617C36.158 190.042 36.5914 192.676 37.8258 195.002H37.8368Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3681 186.218C46.3681 186.218 48.4529 190.146 48.9522 195.556L46.3681 186.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3681 186.218C46.3681 186.218 48.4529 190.146 48.9522 195.556",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6325 185.571C49.6325 185.571 51.7173 189.499 52.2166 194.909L49.6325 185.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6325 185.571C49.6325 185.571 51.7173 189.499 52.2166 194.909",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7433 184.402C52.7433 184.402 54.8281 188.331 55.3273 193.74L52.7433 184.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7433 184.402C52.7433 184.402 54.8281 188.331 55.3273 193.74",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0131 183.705C56.0131 183.705 58.098 187.634 58.5972 193.043L56.0131 183.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0131 183.705C56.0131 183.705 58.098 187.634 58.5972 193.043",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0157 188.363C58.0157 188.363 60.918 185.686 59.5464 184.276C58.1693 182.872 57.3299 185.895 58.0157 188.363Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0157 188.363L55.1902 186.542",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0157 188.363C58.0157 188.363 61.9165 188.967 61.5653 190.904C61.2087 192.84 58.8222 190.799 58.0157 188.363Z",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0157 188.363L56.688 191.458",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.234 146.705L133.596 153.722L127.901 157.162L121.806 152.987L129.234 146.705Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1203 151.747L56.8635 155.314H61.2362L59.7768 147.133L54.1203 151.747Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36 144.588C146.308 147.83 134.518 155.357 134.518 155.357L126.486 141.175L68.555 140.489L53.0011 152.625C53.0011 152.625 47.8769 147.671 42.4069 141.861C36.9425 136.051 34.4298 130.466 45.8524 109.87C57.1269 89.5375 60.7534 84.9838 65.543 83.9524C70.3271 82.9319 84.6081 81.9937 84.6081 81.9937C84.6081 81.9937 88.3937 88.6597 95.8277 88.4457C103.262 88.2317 106.46 81.2311 106.46 81.2311C106.46 81.2311 117.082 81.8237 124.467 83.8097C131.999 87.5734 127.572 84.5668 144.014 114.791C153.352 129.456 150.412 141.345 148.36 144.593V144.588Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8594 50.2661C81.8594 50.2661 85.0799 41.1423 90.1713 43.3313C95.2681 45.5204 105.632 54.5619 112.775 49.9808C119.924 45.3997 114.114 32.814 113.099 29.7032C113.099 29.7032 113.412 34.5257 95.6412 30.3396C90.292 29.0777 86.4405 30.0817 83.84 32.1995C78.1067 36.8629 78.3865 46.9359 81.8649 50.2661H81.8594Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.584 55.6647C100.584 54.9569 101.149 54.3699 101.868 54.3699C102.587 54.3699 103.157 54.935 103.163 55.6537C103.168 56.3724 102.598 56.943 101.879 56.9485C101.16 56.954 100.59 56.3834 100.584 55.6647Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4745 55.6647C89.4745 54.9569 90.0396 54.3699 90.7583 54.3699C91.477 54.3699 92.0476 54.935 92.0531 55.6537C92.0586 56.3724 91.488 56.943 90.7693 56.9485C90.0506 56.954 89.48 56.3834 89.4745 55.6647Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0322 69.1172C95.0322 67.9541 95.5973 66.994 96.316 66.994C97.0347 66.994 97.6053 67.9212 97.6108 69.0953C97.6163 70.2694 97.0457 71.2075 96.327 71.2185C95.6082 71.2295 95.0377 70.2913 95.0322 69.1172Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 178.85C127.424 181.083 126.431 184.589 125.8 186.41C124.56 190.004 121.959 191.946 120.549 193.087C118.958 194.376 118.645 194.547 117.104 194.514C113.812 194.442 105.253 195.452 72.774 191.156C39.9545 186.811 35.944 179.086 32.6741 173.808C29.4043 168.53 33.4258 161.491 39.8942 158.348C46.3626 155.204 59.3214 154.452 59.3214 154.452C59.3214 154.452 129.245 155.357 131.873 155.357C133.98 155.357 144.025 156.246 149.128 159.406C152.387 161.425 153.243 162.495 153.808 163.126C156.831 166.5 160.539 171.855 153.166 178.856C153.166 178.856 148.716 182.773 140.3 181.171C131.851 179.563 125.399 178.856 125.399 178.856L125.41 178.85Z",
    fill: "#191A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3324 154.447C59.3324 154.447 56.3368 117.946 56.1997 116.316C55.9692 113.579 56.9403 112.591 58.9922 112.591C64.6103 112.591 128.872 112.46 130.908 112.745C132.345 112.948 132.905 113.749 132.641 115.543C130.09 133.022 128.526 153.459 128.049 155.314L59.3269 154.447H59.3324Z",
    fill: "white",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2008 52.2796C95.9868 57.1899 95.8442 59.2747 95.8222 62.1934C95.8112 62.9286 96.3928 63.5321 97.128 63.565L98.4008 63.6199",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4242 132.644L92.8431 137.658L92.6621 137.861L90.259 135.76L88.6186 137.582L90.3468 139.079L92.8431 141.247L92.8815 141.279L100.387 132.688L97.4242 132.644Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.622 41.4605C137.815 34.4105 149.32 34.4105 156.512 41.4605",
    stroke: "#222221",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.091 47.9344C140.684 44.4121 146.439 44.4121 150.038 47.9344",
    stroke: "#222221",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07 33.7302C135.598 24.3101 151.525 24.3101 162.059 33.7302",
    stroke: "#222221",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.565 54.4083H143.587",
    stroke: "#222221",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.059 37.1537C166.174 37.1537 169.51 33.818 169.51 29.7032C169.51 25.5884 166.174 22.2527 162.059 22.2527C157.944 22.2527 154.609 25.5884 154.609 29.7032C154.609 33.818 157.944 37.1537 162.059 37.1537Z",
    fill: "#0058BB",
    stroke: "#0058BB",
    strokeWidth: 0.41,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.861 32.9017L165.263 26.4991",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.258 32.9017L158.855 26.4991",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5927_53070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188.621,
    height: 200,
    fill: "white",
    transform: "translate(0.189362)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.9bc42826b668506f5d93374250db3b1a.svg";
export { ForwardRef as ReactComponent };